export const updateListMethod = (method = 'POST', data = null, list = []) => {
  if (!data) {
    return list
  }
  let items = [...list]
  if (method === 'POST') {
    items = [...items, { ...data, _id: String(data._id) }]
  } else if (method === 'BATCH_DELETE') {
    items = items.filter(item => !data.includes(String(item._id)))
  } else if (method === 'DELETE') {
    items = items.filter(item => String(item._id) !== String(data))
  } else if (method === 'BATCH_PUT') {
    items = items.map(item => {
      const find = data.find(d => String(d._id) === String(item._id))
      if (find) {
        return {
          ...item,
          ...find
        }
      }
      return item;
    })
  } else {
    items = items.map(item => {
      if (String(item._id) === String(data._id)) {
        return {
          ...item,
          ...data
        }
      }
      return item;
    })
  }

  return items
}